import { render, staticRenderFns } from "./AdminArtikli.vue?vue&type=template&id=5d5d802e&scoped=true&"
import script from "./AdminArtikli.vue?vue&type=script&lang=js&"
export * from "./AdminArtikli.vue?vue&type=script&lang=js&"
import style0 from "./AdminArtikli.vue?vue&type=style&index=0&id=5d5d802e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5d802e",
  null
  
)

export default component.exports